module.exports = __webpack_public_path__ + "img/powered1.1.b03bf462.png";